import React, { useEffect, createElement } from 'react';
interface MetaTagsProps {
  title: string;
  description: string;
  imageUrl?: string;
  url: string;
  type?: string;
}
export function MetaTags({
  title,
  description,
  imageUrl,
  url,
  type = 'article'
}: MetaTagsProps) {
  useEffect(() => {
    // Store original title to restore later
    const originalTitle = document.title;
    document.title = title;
    // Create or update Open Graph meta tags
    const metaTags = [{
      property: 'og:title',
      content: title
    }, {
      property: 'og:description',
      content: description
    }, {
      property: 'og:url',
      content: url
    }, {
      property: 'og:type',
      content: type
    }, {
      name: 'twitter:card',
      content: 'summary_large_image'
    }, {
      name: 'twitter:title',
      content: title
    }, {
      name: 'twitter:description',
      content: description
    }];
    // Add image tags only if an image URL is provided
    if (imageUrl) {
      metaTags.push({
        property: 'og:image',
        content: imageUrl
      }, {
        name: 'twitter:image',
        content: imageUrl
      });
    }
    // Create or update meta tags
    const existingTags: {
      [key: string]: HTMLMetaElement;
    } = {};
    document.querySelectorAll('meta[property^="og:"], meta[name^="twitter:"]').forEach(tag => {
      const key = tag.getAttribute('property') || tag.getAttribute('name');
      if (key) existingTags[key] = tag as HTMLMetaElement;
    });
    // Create or update each meta tag
    metaTags.forEach(({
      property,
      name,
      content
    }) => {
      const key = property || name;
      if (!key || !content) return;
      if (existingTags[key]) {
        // Update existing tag
        existingTags[key].setAttribute('content', content);
      } else {
        // Create new tag
        const metaTag = document.createElement('meta');
        if (property) metaTag.setAttribute('property', property);
        if (name) metaTag.setAttribute('name', name);
        metaTag.setAttribute('content', content);
        document.head.appendChild(metaTag);
      }
    });
    // Cleanup function to restore original meta tags when component unmounts
    return () => {
      document.title = originalTitle;
      metaTags.forEach(({
        property,
        name
      }) => {
        const key = property || name;
        if (!key) return;
        const tag = existingTags[key];
        if (tag && tag.parentNode) {
          tag.parentNode.removeChild(tag);
        }
      });
    };
  }, [title, description, imageUrl, url, type]);
  return null; // This component doesn't render anything
}